import { AppIcon } from "@bednbody/ui/components/branding/app-icon";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@bednbody/ui/components/sidebar";

export function AppBrand() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        >
          <AppIcon size="sm" />
          <h4 className="text-primary type-title-subsection font-wordmark">Bednbody</h4>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
